export const defaultAttributeDisplayOptions = {
    inlineLabel: false,
    inlineValues: false,
    fullWidth: true,
    margin: undefined,
    size: undefined,
    variant: undefined,
    showDisallowedValues: false,
    valueSorting: [], // by default, do not sort at all
};
//# sourceMappingURL=AttributeDisplayOptions.js.map